module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/icon-reset-bf12a9f469198014713a9085a7ef3c87.svg";